import {
  Action,
  Container,
  Heading3,
  Heading5,
  Icon,
  ModalWrapper,
  Paragraph,
  YoutubeVideo,
} from "shared/components";
import { useToggle } from "shared/hooks";
import { parseYouTubeId } from "shared/utils";

import styles from "./Content021.module.scss";

export const Content021 = ({ payload }) => {
  const title = payload?.title ?? "";
  const subtitle = payload?.subtitle ?? "";
  const description = payload?.description ?? "";
  const { videoLink } = payload?.videoLink ?? null;
  const { buttonText } = payload?.videoLink ?? "";

  const videoId = parseYouTubeId(videoLink);

  const { opened, onOpen, onClose } = useToggle();

  return (
    <div className={styles.wrapper}>
      <Container className={styles.inner}>
        <Heading3 className={styles.title}>{title}</Heading3>
        <div className={styles.content}>
          {videoId && (
            <Action onClick={onOpen} className={styles.button}>
              <span className={styles.play}>
                <Icon className={styles.icon} name="arrow_right" />
              </span>
              <Paragraph
                color="brand"
                className={styles["button-text"]}
                appearance="bigger"
              >
                {buttonText}
              </Paragraph>
            </Action>
          )}
          {opened && (
            <ModalWrapper onCloseModal={onClose} appearance="full-area">
              <YoutubeVideo id={videoId} />
            </ModalWrapper>
          )}
          <div className={styles.text}>
            <Heading5 className={styles.subtitle}>{subtitle}</Heading5>
            <Paragraph color="dark">{description}</Paragraph>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content021;
